import { render } from "./GallaryCom.vue?vue&type=template&id=26f82b02&scoped=true"
import script from "./GallaryCom.vue?vue&type=script&lang=js"
export * from "./GallaryCom.vue?vue&type=script&lang=js"

import "./GallaryCom.vue?vue&type=style&index=0&id=26f82b02&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26f82b02"]])

export default __exports__